import { Card, Flex, Text } from "@jsq/ds/core";
import { Icon, IconType } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { BackButtonWithinForm } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/OwnersAndControllersCard/CreateOwnersAndControllersFullscreenTakeover/BackButtonWithinForm";
import {
  dividerStyle,
  optionRowStyle,
  sectionLabelStyle,
} from "../ProfileCategorySelector/styles_vanilla.css";
import { deferredOptionRowStyle } from "./styles_vanilla.css";

type MethodOption = {
  label: string;
  onClick?: () => void;
  testId: string;
  icon: IconType;
  disabled?: boolean;
};

interface Props {
  backLabel: string;
  onBack: () => void;
  onSelectManual: () => void;
  onSelectExtraction?: () => void;
  title?: string;
}

const ProfileMethodSelector = ({
  backLabel,
  onBack,
  onSelectManual,
  onSelectExtraction,
  title = "Compliance profile",
}: Props) => {
  const options: MethodOption[] = [
    {
      label: "Upload document to create profile with extracted data",
      onClick: onSelectExtraction,
      testId: "profile-method-upload",
      icon: "arrow-up-from-bracket",
      disabled: !onSelectExtraction,
    },
    {
      label: "Manually create profile",
      onClick: onSelectManual,
      testId: "profile-method-manual",
      icon: "plus",
    },
  ];

  return (
    <Card>
      <BackButtonWithinForm onClick={onBack} displayText={backLabel} />
      <Text variant="h3" marginBottom="sm">
        {title}
      </Text>
      <Text className={sectionLabelStyle}>Choose a method to create a profile</Text>
      {options.map((option, index) => (
        <div key={option.label}>
          <button
            className={
              option.disabled ? `${optionRowStyle} ${deferredOptionRowStyle}` : optionRowStyle
            }
            data-testid={option.testId}
            onClick={option.onClick}
            type="button"
            disabled={option.disabled}
          >
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center" gap={Sizes.SM}>
                <Icon
                  type={option.icon}
                  color={Colors.Neutral800}
                  variant="outline"
                  size="medium"
                />
                <Text asSpan variant="regular-md">
                  {option.label}
                </Text>
              </Flex>
              <Icon
                type="chevron-right"
                color={Colors.Neutral600}
                variant="outline"
                size="large"
              />
            </Flex>
          </button>
          {index < options.length - 1 && <div className={dividerStyle} />}
        </div>
      ))}
    </Card>
  );
};

export default ProfileMethodSelector;
